export const MessageTypes = {
    CATEGORY_CHOICE: 'CATEGORY_CHOICE',
    DIFF_REVIEW: 'DIFF_REVIEW',
    SYSTEM: 'SYSTEM',
}

export const RubricRefinementTypes = {
    SINGLE_SUBMISSION: 'SingleSubmission',
    MULTIPLE_SUBMISSIONS: 'MultipleSubmissions',
}

export const RefinementItemTypes = {
    SUBMISSION: 'Submission',
    SUGGESTION: 'RubricSuggestion',
}

export const RefinementItemStatus = {
    READY: 'Ready',
    SKIPPED: 'Skipped',
    PROCESSED: 'Processed',
    IRRELEVANT: 'Irrelevant',
}
